import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import Accordion from '@mui/joy/Accordion';
import AccordionDetails from '@mui/joy/AccordionDetails';
import AccordionGroup from '@mui/joy/AccordionGroup';
import AccordionSummary from '@mui/joy/AccordionSummary';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Chip from '@mui/joy/Chip';
import Button from '@mui/joy/Button';
import { ColorPaletteProp, VariantProp } from '@mui/joy';

import { DateOrTime, Duration } from 'components/Date';
import IdentityAvatar from 'components/IdentityAvatar';
import FancyIcon from 'components/FancyIcon';

// import useUserIdentity from 'hooks/useUserIdentity';
import useRequestDelay from 'hooks/useRequestDelay';

import { RequestDelayType } from 'stores/request_delay_store';
import { FHRequestType } from 'stores/fhrequest_store';

import pluralize from 'utils/pluralize';

import useWorkKey from 'hooks/useWorkKey';

const DelayItem = ({ delay }: { delay: RequestDelayType }) => {

    const workKey = useWorkKey();
    const { doCancel } = useRequestDelay();
    const [isCancelling, setIsCancelling] = useState(false);

    var chipColor = 'neutral' as ColorPaletteProp;
    var chipVariant = 'outlined' as VariantProp;
    if(delay.status == 'scheduled') {
        chipColor = 'warning';
        chipVariant = 'outlined';
    }
    else if(delay.status == 'fired') {
        chipColor = 'warning';
        chipVariant = 'solid';
    }
    else if(delay.status == 'expired') {
        chipColor = 'danger';
    }
    else if(delay.status == 'resolved') {
        chipColor = 'success';
    }

    async function cancelClick() {
        setIsCancelling(true);
        workKey && await doCancel(workKey, delay.uuid);
        setIsCancelling(false);
    }


    return (
        <Stack pb={1}>

            <Stack direction="row" spacing={0.5}>
                <Typography level="body-sm">
                    <Duration start={delay.date_created} end={delay.scheduled_time} /> delay by
                </Typography>
                <Typography level="body-sm">
                    <IdentityAvatar identityKey={delay.identity} size="name" />
                </Typography>

            </Stack>
            <Stack direction="row" spacing={0.5}>
                <Typography level="body-sm">
                    From <DateOrTime ts={delay.date_created} /> until <DateOrTime ts={delay.scheduled_time} />
                </Typography>

            </Stack>

            <Stack direction="row" spacing={1}>
                <Chip color={chipColor} variant={chipVariant} >{delay.status}</Chip>
            </Stack>
            {workKey && delay.status == 'scheduled' &&
                <Stack direction="row" mt={1}>
                <Button size="sm" loading={isCancelling} variant="outlined" onClick={cancelClick}>Cancel Delay</Button>
                </Stack>
            }
        </Stack>
    );
};

const RequestDelayList = observer(({ request }: { request: FHRequestType }) => {
    const {
        fetchListByRequest,
        getListByRequest,
        items
    } = useRequestDelay();

    const workKey = useWorkKey();
    const [delays, setDelays] = useState([] as RequestDelayType[]);


    useEffect(() => {
        if(!workKey) return;
        fetchListByRequest(workKey, request.uuid);
    }, [workKey]);

    useEffect(() => {
        if(items.length > 0) {
            var dlys = getListByRequest(request.uuid);
            // sort by date created decending
            dlys.sort((a, b) => a.date_created > b.date_created ? -1 : 1);
            setDelays(dlys);
        }
    }, [items.length]);


    return (

        <AccordionGroup size="lg">
            <Accordion>
                <AccordionSummary>
                    <FancyIcon name="DayOnesDelay" />

                    <Typography level="body-sm">
{pluralize(delays?.length, 'Delay')}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>


                    {delays &&
                        delays.map((c) =>
                            <DelayItem key={c.key} delay={c} />
                        )
                                      }

                </AccordionDetails>
            </Accordion>
        </AccordionGroup>

    );

});

export default RequestDelayList;
